<template>
  <v-form ref="newsEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'news-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование новости' : 'Создание новости'}}</h1>
      </v-col>
      <v-col cols="12">
      <div class="">
        <v-img :src="previewImage(true, image)" width="655" height="190">
          <template v-slot:placeholder>
            <div class="image-placeholder"></div>
          </template>
        </v-img>
      </div>
      </v-col>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-file-input label="Картинка"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="3840х1220.jpg"
                      append-icon="mdi-attachment"
                      v-model="image">
        </v-file-input>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang">
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="news.name"
                        label="Заголовок"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
                <v-textarea
                        v-model="news.description"
                        label="Описание"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-textarea>
                <v-text-field
                        v-model="news.button_text"
                        label="Кнопка"
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                    v-model="news.name_ua"
                    label="Заголовок"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
                <v-textarea
                    v-model="news.description_ua"
                    :rules="[rules.required]"
                    required
                    label="Описание"
                    outlined
                ></v-textarea>
                <v-text-field
                    v-model="news.button_text_ua"
                    label="Кнопка"
                    outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-text-field
                v-model="news.button_url"
                label="Ссылка"
                outlined
        ></v-text-field>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import NewsService from './../../api/NewsService'

  export default {
    name: 'NewsEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      news: {
        name_ua: '',
        description: '',
        description_ua: '',
        button_text: '',
        button_text_ua: '',
        button_url: '',
      },
      image: null,
      loading: true,
      loadingButton: false,
    }),
    mounted() {
        if(this.id) {
            NewsService.get(this.id)
                .then(response => {
                    this.news = response.data;

                    if (this.news.image) {
                        this.image = this.news.image;
                        this.image.name = this.news.image.file
                    }
                    this.loading = false
                });
        }
    },
    methods: {
      validate() {
        this.$refs.newsEditForm.validate()
        if(this.news.name == '' && this.news.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.news.name != '' && this.news.name_ua == ''){
          this.tabLang = 1;
        }

        if (this.news.description == '' && this.news.description_ua != '') {
          this.tabLang = 0;
        }
        if (this.news.description != '' && this.news.description_ua == '') {
          this.tabLang = 1;
        }

      },
      previewImage(isList, image) {
        if(this.image && this.image.url){
            return this.image.url
        }
        if(image){
          return URL.createObjectURL(image)
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }

        this.loadingButton = true;
        let formData = this.getData();

        NewsService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Новость успешно обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении новости';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        NewsService.create(formData).then(response => {
            this.$router.push({ name: 'news-edit', params: { id: response.data.id } })
          this.news.id = response.id
          this.snackbar = true;
          this.snackbarText = 'Новость создан';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании новости';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('id', this.id);
          formData.append('name', this.news.name);
          formData.append('name_ua', this.news.name_ua);
          formData.append('description', this.news.description);
          formData.append('description_ua', this.news.description_ua);
          formData.append('button_text', this.news.button_text);
          formData.append('button_text_ua', this.news.button_text_ua);
          formData.append('button_url', this.news.button_url);
          if(this.image && !this.image.url) {
              formData.append('image', this.image);
          }

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .news-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .news{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
